import React from 'react';
import { Link } from 'react-router-dom';

const Frota = () => {
  const modulos = [
    {
      title: 'Veículos',
      description: 'Gerencie sua frota, documentos e odômetro',
      icon: '🚛',
      path: '/frota/veiculos',
      gradient: 'from-indigo-500 to-blue-600',
      stats: 'Cadastro completo'
    },
    {
      title: 'Ordens de Serviço',
      description: 'Controle de viagens e ordens de serviço',
      icon: '📋',
      path: '/frota/ordens-servico',
      gradient: 'from-emerald-500 to-green-600',
      stats: 'Viagens e OS'
    },
    {
      title: 'Manutenções',
      description: 'Controle de manutenções preventivas e corretivas',
      icon: '🔧',
      path: '/frota/manutencoes',
      gradient: 'from-amber-500 to-orange-600',
      stats: 'Preventiva e corretiva'
    },
    {
      title: 'Histórico de Pontos',
      description: 'Histórico de pontos por veículo',
      icon: '📍',
      path: '/frota/veiculos',
      gradient: 'from-purple-500 to-violet-600',
      stats: 'Por veículo'
    }
  ];

  return (
    <div className="space-y-6 max-w-6xl mx-auto">
      {/* Header */}
      <div className="bg-gradient-to-br from-indigo-950 via-indigo-900 to-purple-900 rounded-2xl p-6 md:p-8 text-white shadow-xl">
        <p className="text-indigo-300 text-sm font-medium uppercase tracking-widest mb-1">Operação</p>
        <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Gestão de Frota</h1>
        <p className="text-indigo-200 mt-1 text-sm">Gerencie veículos, ordens de serviço e manutenções</p>
      </div>

      {/* Cards de módulos */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {modulos.map((modulo, i) => (
          <Link
            key={i}
            to={modulo.path}
            className="group bg-white rounded-2xl shadow-lg border border-gray-100 p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
          >
            <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${modulo.gradient} flex items-center justify-center text-2xl mb-4 shadow-lg group-hover:scale-110 transition-transform`}>
              {modulo.icon}
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-1 group-hover:text-indigo-700 transition-colors">
              {modulo.title}
            </h3>
            <p className="text-sm text-gray-500 mb-3">{modulo.description}</p>
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-indigo-50 text-indigo-700 border border-indigo-100">
              {modulo.stats}
            </span>
          </Link>
        ))}
      </div>

      {/* Resumo rápido */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 border-t-4 border-indigo-500">
          <p className="text-sm font-medium text-gray-500">🚛 Frota ativa</p>
          <p className="text-3xl font-bold text-gray-900">17</p>
          <p className="text-xs text-gray-400 mt-1">veículos cadastrados</p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 border-t-4 border-amber-500">
          <p className="text-sm font-medium text-gray-500">🔧 Em manutenção</p>
          <p className="text-3xl font-bold text-gray-900">1</p>
          <p className="text-xs text-gray-400 mt-1">veículo na oficina</p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 border-t-4 border-emerald-500">
          <p className="text-sm font-medium text-gray-500">✅ Disponíveis</p>
          <p className="text-3xl font-bold text-gray-900">16</p>
          <p className="text-xs text-gray-400 mt-1">prontos para operar</p>
        </div>
      </div>
    </div>
  );
};

export default Frota;
